import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, House } from "lucide-react";

/**
 * Ancestor trail for the current page. Items are { label, href?, isHome? };
 * items without href (sidebar sections) render as plain text.
 * On small screens only the home link and the direct parent stay visible.
 */
function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  const lastIndex = items.length - 1;
  const collapsible = (i) => i > 0 && i < lastIndex;
  const hasCollapsed = items.some((_, i) => collapsible(i));

  return (
    <nav aria-label="Breadcrumb" className="min-w-0">
      <ol className="flex min-w-0 items-center gap-1 text-xs text-app-muted">
        {items.map((item, i) => (
          <Fragment key={`${item.label}-${i}`}>
            {i === 1 && hasCollapsed && (
              <li aria-hidden="true" className="flex items-center gap-1 sm:hidden">
                <span>…</span>
                <ChevronRight className="h-3.5 w-3.5 shrink-0 opacity-60" />
              </li>
            )}
            <li
              className={`min-w-0 items-center gap-1 ${collapsible(i) ? "hidden sm:flex" : "flex"}`}
            >
              {item.href ? (
                <Link
                  to={item.href}
                  className="inline-flex min-w-0 items-center gap-1 rounded transition-colors hover:text-[#2470B7] focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 dark:hover:text-blue-400"
                >
                  {item.isHome && <House className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />}
                  <span className={item.isHome ? "sr-only sm:not-sr-only" : "truncate"}>{item.label}</span>
                </Link>
              ) : (
                <span className="truncate">{item.label}</span>
              )}
              <ChevronRight className="h-3.5 w-3.5 shrink-0 opacity-60" aria-hidden="true" />
            </li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
